import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import App from "./App";
import "./index.css";
import reducers from "./reducers";
// import store from "./Store";
import { ToastProvider } from "react-toast-notifications";
import "../node_modules/bootstrap/scss/bootstrap.scss";
import "../node_modules/font-awesome/scss/font-awesome.scss";
import Toaster from "./AppComponents/Toaster";
import "./assets/assets/scss/color_skins.scss";
import "./assets/assets/scss/main.scss";
import * as serviceWorker from "./serviceWorker";
import Popup from "./AppComponents/Popup";

const store = createStore(reducers, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ToastProvider placement="bottom-left">
        <App />
        <Toaster />
        <Popup />
      </ToastProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
